import { Outlet } from 'react-router';

import { AppLayout } from 'components/navigation/AppLayout';

const FavoritesWatchlistLayout = () => {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default FavoritesWatchlistLayout;
